export enum StorageKeysEnum {
  USER = 'user',
  AUTH = 'auth'
}
